import { useQuery } from "react-query";
import {
  getCustomer,
  getCustomers,
  getCustomerOrder,
  getCustomerLoyaltyActivities,
} from "../../../services/customer";

export const useGetCustomerDetails = (customerId) => {
  return useQuery(
    ["getCustomerDetails", `${customerId}`],
    () => getCustomer(customerId).then((res) => res?.data?.data),
    {
      enabled: !!customerId,
      staleTime: Infinity,
    },
  );
};

export const useGetCustomers = ({
  queries = "",
  queryParams = {},
  isEnabled = true,
}) => {
  return useQuery(
    ["getCustomers", queries, queryParams],
    () => getCustomers(queries, queryParams).then((res) => res?.data),
    {
      staleTime: Infinity,
      enabled: isEnabled,
    },
  );
};

export const useGetCustomerOrderDetails = (customerId) => {
  return useQuery(
    ["getCustomerOrderDetails", customerId],
    () => getCustomerOrder(customerId).then((res) => res?.data?.data),
    {
      staleTime: Infinity,
    },
  );
};

export const useGetCustomerLoyaltyActivites = ({
  queryParams = {},
  isEnabled = true,
}) => {
  return useQuery(
    ["getCustomerLoyaltyActivities", queryParams],
    () => getCustomerLoyaltyActivities(queryParams).then((res) => res?.data),
    {
      enabled: isEnabled,
      staleTime: Infinity,
    },
  );
};
